export default "__VITE_ASSET__6c614001__"